import {Section} from '@primer/react-brand/esm'

import styles from './styles.module.css'

import {ContentfulFaqGroup} from '@github-ui/swp-core/components/contentful/ContentfulFaqGroup'
import type {PrimerComponentFaqGroup} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentFaqGroup'

type Props = {
  contentfulContent: PrimerComponentFaqGroup
}

export function FaqSection({contentfulContent}: Props) {
  const sectionId = contentfulContent.fields.htmlId

  return (
    <Section id={sectionId} className={styles.FaqSection} fullWidth paddingBlockEnd="none">
      <ContentfulFaqGroup component={contentfulContent} variant="gridline" headingLevel="h2" />
    </Section>
  )
}
